import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    paper: {
      borderRadius: theme.shape.borderRadius,
    },
    item: {
      ...theme.typography.regular14,
      '& svg': {
        marginRight: theme.spacing(1),
        fontSize: theme.typography.pxToRem(16),
      },
    },
    actionDots: {
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'ProjectActionsDropdown' }
);
